module.exports = __webpack_public_path__ + "static/images/dialog-head-mask.da5fd2d.png";